<template>
  <div class="pages">
    <div class="headerTop">
      <div class="headerTop-title">已摄入营养成分</div>
      <div class="headerTop-content">
        <div class="circlediv">
          <div class="headerTop-content-text">
            <div class="text-title">还可以吃</div>
            <div class="text-num">{{ parseInt(ResidualIntake) || 0 }}千卡</div>
            <div class="text-pricetext">推荐</div>
            <div class="text-pricetext">
              {{ minNum(userData.suggestEngine) }}千卡
            </div>
          </div>
          <van-circle
            v-model="currentRate"
            :rate="rate"
            :clockwise="false"
            layer-color="#E7EEFA"
            color="#C4D4F2"
            size="40vw"
            :stroke-width="60"
            class="headerTop-content-circle"
          >
          </van-circle>
        </div>

        <div class="headerTop-content-number">
          <div class="number-title">营养摄入</div>
          <div class="number-num">{{ parseInt(userData.engine) || 0 }}千卡</div>
        </div>
      </div>
      <div class="headerTop-charts">
        <div id="chart1" class="chart"></div>
        <div id="chart2" class="chart"></div>
        <div id="chart3" class="chart"></div>
      </div>
      <div class="headerTop-chartstext">
        <div v-for="(i, index) in chartstextList" :key="index">
          <div>{{ i.name }}</div>
          <div>（摄入{{ i.weight }}{{ i.unit }}）</div>
        </div>
      </div>
    </div>

    <div class="headerToDay" @click="GoToDay">
      <div class="headerToDay-title">今日营养分析</div>
      <div class="headerToDay-icon"><van-icon name="arrow" /></div>
    </div>

    <div class="headerTabbar">
      <van-tabs v-model="tabActive">
        <van-tab title="饮食记录">
          <template #title>
            <div
              :class="
                tabActive ? 'headerTabbar-titlebar' : 'headerTabbar-isactive'
              "
            >
              {{ "饮食记录" }}
            </div>
          </template>

          <DietRecord
            v-if="dietRecordList && dietRecordList.length"
            :dataList="dietRecordList"
          />
          <div v-else style="text-align: center; line-height: 150px">
            暂无记录
          </div>
        </van-tab>
        <van-tab title="运动建议">
          <template #title>
            <div
              :class="
                tabActive ? 'headerTabbar-isactive' : 'headerTabbar-titlebar'
              "
            >
              {{ "运动建议" }}
            </div>
          </template>
          <SportsAdvice :netContent="userData.engine" />
        </van-tab>
      </van-tabs>
    </div>

    <!-- <van-button type="primary" text="显示遮罩层" @click="show = true" />
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <img src="../../assets/image/Frame.png" alt="" srcset="" />
          <div class="noText">没有找到您的健康档案</div>
          <div class="gobutton" @click="GotoBtn">现在就去填写</div>
        </div>
      </div>
    </van-overlay> -->
    <gopage :show="show" />
  </div>
</template>

<script>
import DietRecord from "./components/dietRecord.vue";
import SportsAdvice from "./components/sportsAdvice.vue";
import gopage from "../../components/gopage.vue";
import { userHomePageView, getUserHealthyProfile } from "@/apis/stems.js";
export default {
  components: {
    DietRecord,
    SportsAdvice,
    gopage,
  },
  data() {
    return {
      show: false,
      tabActive: 0, //首页tab
      userData: [], //摄入数据
      dietRecordList: [], //饮食记录
      ResidualIntake: 0, //剩余可摄入量
      chartstextList: [], //主要摄入
      rate: 70,
      currentRate: 0,
      customerId: "",
    };
  },
  watch: {
    tabActive() {},
  },
  mounted() {
    try {
      let roles = JSON.parse(localStorage.getItem("customerInfoList"));
      this.customerId =
        (roles && roles[0].customerId) || localStorage.getItem("customerId");
      let userName = this.$route.query.realName;
      let userimg = this.$route.query.img;
      if (this.customerId) {
        sessionStorage.setItem("customerId", this.customerId);
        sessionStorage.setItem("userName", userName);
        sessionStorage.setItem("userimg", userimg);
      } else {
        console.log("customerId null");
      }
    } catch (error) {}

    this.getUserHomePageView();
  },
  methods: {
    pushHistory() {
      var state = {
        title: "home",
        url: "#",
      };
      window.history.pushState(state, state.title, state.url);
    },
    getUserHealthyProfile() {
      getUserHealthyProfile({
        userCode: this.customerId,
      }).then((res) => {
        if (res.data.data == null) {
          this.show = true;
        } else {
          this.show = false;
        }
      });
    },
    getUserHomePageView() {
      userHomePageView({
        userCode: this.customerId,
        // queryDate: "2022-03-29",
        queryDate: this.dayjs(new Date()).format("YYYY-MM-DD"),
      }).then((res) => {
        this.dietRecordList = res.data.data.meals; //饮食记录
        this.userData = res.data.data; //用户数据
        this.ResidualIntake =
          this.userData.suggestEngine - this.userData.engine;

        // 剩余可摄入量不为负数
        this.ResidualIntake < 0 ? (this.ResidualIntake = 0) : "";
        // 剩余可摄入量 占比
        this.ResidualIntake
          ? (this.rate =
              (this.ResidualIntake / this.userData.suggestEngine) * 100)
          : (this.rate = 0);
        this.chartstextList = [
          {
            name: "蛋白质",
            weight: this.userData.proteinWeight,
            unit: this.userData.proteinUnit,
            num:
              this.userData.proteinWeight / this.userData.suggestProteinWeight,
          },
          {
            name: "碳水化合物",
            weight: this.userData.carbohydrateWeight,
            unit: this.userData.carbohydrateUnit,
            num:
              this.userData.carbohydrateWeight /
              this.userData.suggestCarbohydrateWeight,
          },
          {
            name: "脂肪",
            weight: this.userData.fatWeight,
            unit: this.userData.fatUnit,
            num: this.userData.fatWeight / this.userData.suggestFatWeight,
          },
        ];
        let charts1 = document.getElementById("chart1");
        let charts2 = document.getElementById("chart2");
        let charts3 = document.getElementById("chart3");
        this.getEcharts(charts1, this.chartstextList[0].num);
        this.getEcharts(charts2, this.chartstextList[1].num);
        this.getEcharts(charts3, this.chartstextList[2].num);
      });
    },
    async GoToDay() {
      // 今日营养分析
      await this.getUserHealthyProfile();
      if (this.show == true) {
      } else {
        if (this.userData.engine && this.userData.engine != 0) {
          this.$router.push("/dayNutrisystem");
        } else {
          this.$notify({
            type: "success",
            message: "今日暂无摄入",
            duration: 1000,
          });
        }
      }
    },
    GotoBtn() {
      this.$router.push("/recordsHealth");
    },
    minNum(num) {
      if (num) {
        if (num <= 0) {
          return 0;
        } else {
          return num;
        }
      } else {
        return 2600;
      }
    },
    getEcharts(chart, data) {
      let myChart = this.$echarts.init(chart);
      let option = {
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 1,
            splitNumber: 4,
            splitLine: {
              show: false, //是否显示分隔线。
            },
            axisLine: {
              lineStyle: {
                width: 8,
                color: [
                  [0.25, "#067EFA"],
                  [0.75, "#23FC8F"],
                  [1, "#F2786D"],
                ],
              },
            },
            pointer: {
              icon: "path://M511.999488 819.413462 72.8374 204.586538 951.1626 204.586538Z",
              length: "15%",
              width: 10,
              offsetCenter: [0, "-108%"],
              itemStyle: {
                color: "#23FC8F",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#CCC",
              fontSize: 6,
              distance: -10,
              formatter: function (value) {
                if (value === 0.25) {
                  return "18%";
                } else if (value === 0.75) {
                  return "28%";
                }
                return "";
              },
            },
            title: {
              offsetCenter: [0, "-20%"],
              fontSize: 10,
            },
            detail: {
              fontSize: 15,
              offsetCenter: [0, "-25%"],
              valueAnimation: true,
              formatter: function (value) {
                return Math.round(value * 100) + "%";
              },
              color: "auto",
            },
            data: [
              {
                value: data,
              },
            ],
          },
        ],
      };
      option && myChart.setOption(option);
    },
  },
};
</script>
<style scoped>
::v-deep .van-tabs__line {
  position: absolute;
  width: 36px;
  height: 6px;
  background: #fbd561;
  border-radius: 4px 4px 4px 4px;
}
</style>
<style lang="less" scoped>
.pages {
  background: #f7f8fa;
  padding: 14px;
}
.headerTop {
  width: 343px;
  height: 334px;
  margin: 0 auto;
  padding: 15px;
  box-sizing: border-box;
  background: #ffffff;
  position: relative;
  border-radius: 8px 8px 8px 8px;
  box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.1);
  &-title {
    font-size: 17px;
    font-family: "HarmonyOS Sans SC-Regular, HarmonyOS Sans SC";
    font-weight: 400;
    color: #202020;
    position: relative;
  }
  &-title::before {
    content: "";
    height: 16px;
    width: 2px;
    background-color: #4bd891;
    position: absolute;
    left: -7px;
    top: 3px;
  }
  &-content {
    margin-top: 20px;
    display: flex;
    position: relative;
    &-circle {
      position: absolute;
      top: 0;
      left: 5px;
    }
    &-text {
      margin-top: 20px;
      text-align: center;
      .text-title {
        font-size: 16px;
        font-family: "HarmonyOS Sans SC-Light, HarmonyOS Sans SC";
        font-weight: 300;
        color: #606060;
        line-height: 22px;
      }
      .text-num {
        font-size: 25px;
        font-family: "HarmonyOS Sans SC-Bold, HarmonyOS Sans SC";
        font-weight: bold;
        color: #606060;
        line-height: 50px;
      }
      .text-pricetext {
        font-size: 10px;
        font-family: "HarmonyOS Sans SC-Light, HarmonyOS Sans SC";
        font-weight: 300;
        color: #606060;
      }
    }
    &-number {
      text-align: center;
      .number-title {
        margin-top: 20px;
        font-size: 20px;
        font-family: "HarmonyOS Sans SC-Light, HarmonyOS Sans SC";
        font-weight: 300;
        color: #606060;
        line-height: 33px;
      }
      .number-num {
        margin-top: 10px;
        font-size: 30px;
        font-family: "HarmonyOS Sans SC-Medium, HarmonyOS Sans SC";
        font-weight: 500;
        color: #606060;
        line-height: 47px;
      }
    }
  }
  &-content > div {
    width: 50%;
  }
  &-charts {
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: 0px;
    bottom: 12px;
  }
  .chart {
    min-width: 115px;
    min-height: 120px;
    box-sizing: border-box;
  }
  &-chartstext {
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: 0px;
    bottom: 42px;
    font-size: 8px;
    font-family: "HarmonyOS Sans SC-Regular, HarmonyOS Sans SC";
    font-weight: 400;
    color: #606060;
    line-height: 12px;
  }
  &-chartstext > div {
    min-width: 115px;
    text-align: center;
  }
}
.headerToDay {
  width: 343px;
  height: 45px;
  margin: 0 auto;
  background: #ffffff;
  box-sizing: border-box;
  position: relative;
  margin: 10px 0;
  padding: 0 20px;
  box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.1);
  border-radius: 8px 8px 8px 8px;
  display: flex;
  justify-content: space-between;
  line-height: 45px;
  &-title {
    font-size: 15px;
    font-family: "HarmonyOS Sans SC-Regular, HarmonyOS Sans SC";
    font-weight: 400;
    color: #606060;
  }
  &-icon {
    color: #606060;
    font-size: 22px;
  }
}
.headerTabbar {
  width: 343px;
  // min-height: 300px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.1);
  border-radius: 8px 8px 8px 8px;
  box-sizing: border-box;
  position: relative;
  padding: 0 20px;
  &-titlebar {
    font-size: 15px;
    font-family: "HarmonyOS Sans SC-Light, HarmonyOS Sans SC";
    font-weight: 300;
    color: #909090;
  }
  &-isactive {
    font-size: 17px;
    font-family: "HarmonyOS Sans SC-Bold, HarmonyOS Sans SC";
    font-weight: bold;
    color: #202020;
  }
}
.circlediv {
  position: relative;
  min-width: 165px;
  height: 150px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 253px;
  height: 320px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 10px;
  text-align: center;
  img {
    margin-top: 40px;
  }
  .noText {
    font-size: 12px;
    font-weight: 400;
    color: #cccccc;
  }
  .gobutton {
    width: 162px;
    height: 40px;
    margin: 0 auto;
    background: #07c160;
    border-radius: 4px 4px 4px 4px;
    font-size: 17px;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    margin-top: 40px;
  }
}
</style>